/* @flow */
import liferay from 'services/liferay';

import type {
  Action,
  AsyncAction,
  Worklist,
  SimplifiedTrack,
  FindWorklistParams,
  SaveWorklistParams,
  SimplifiedWorklist,
  WorklistItem,
  UpdateWorklistItemParams,
} from 'types/index';

const onFailure = (error: Object) => console.warn(error);

const fetchWorklistList = (params?: FindWorklistParams): AsyncAction => {
  return {
    type: 'FETCH_WORKLIST_LIST_REQUEST',
    payload: params,
    promise: liferay.worklists.find(params),
    meta: { onFailure },
  };
};

const updateWl1 = (id: number): AsyncAction => {
  return {
    type: 'UPDATE_WL1_REQUEST',
    payload: id,
    promise: liferay.worklists.wl1.update(id),
    meta: { onFailure },
  };
};

const updateWl2 = (id: number): AsyncAction => {
  return {
    type: 'UPDATE_WL2_REQUEST',
    payload: id,
    promise: liferay.worklists.wl2.update(id),
    meta: { onFailure },
  };
};

const fetchWorklist = (id: number): AsyncAction => {
  return {
    type: 'FETCH_WORKLIST_REQUEST',
    payload: id,
    promise: liferay.worklists.get(id),
    meta: { onFailure },
  };
};

const createWorklist = (): Action => {
  return {
    type: 'CREATE_WORKLIST',
    meta: { onFailure },
  };
};

const saveWorklist = (
  params: SaveWorklistParams,
  onSuccess?: (worklist: Worklist) => any
): AsyncAction => {
  // $FlowFixMe
  const promise: Promise<Worklist> = params.id
    ? //$FlowFixMe
      liferay.worklists.update(params)
    : liferay.worklists.create(params);
  return {
    type: 'SAVE_WORKLIST_REQUEST',
    promise,
    meta: { onFailure, onSuccess },
  };
};

const deleteWorklist = (id: number, onSuccess?: (id: number) => any): AsyncAction => {
  return {
    type: 'DELETE_WORKLIST_REQUEST',
    payload: id,
    promise: liferay.worklists.delete(id),
    meta: { onFailure, onSuccess },
  };
};

const successMessage = (
  verb: string,
  verbp: string,
  tracks: SimplifiedTrack[],
  worklist: SimplifiedWorklist
): string => {
  switch (tracks.length) {
    case 1:
      return `Traccia "${tracks[0].title}" ${verb} worklist "${worklist.name}"`;
    case 2:
      return `Tracce "${tracks[0].title}" e "${tracks[1].title}" ${verbp} worklist "${worklist.name}"`;
    default:
      return `Tracce "${tracks[0].title}" e altre ${tracks.length - 1} ${verbp} worklist "${
        worklist.name
      }"`;
  }
};

const createWorklistItems = (
  tracks: SimplifiedTrack[],
  worklist: SimplifiedWorklist,
  usageId: ?number,
  onSuccess?: (createdItems: WorklistItem[]) => any
): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'CREATE_WORKLIST_ITEMS_REQUEST',
    payload: { tracks, worklist, usageId },
    promise: liferay.worklists.items.create(tracks, worklist, usageId),
    meta: {
      onFailure,
      onSuccess,
      successMessage: successMessage('aggiunta a', 'aggiunte a', tracks, worklist),
    },
  };
};

const fetchWorklistItems = (worklistId: $PropertyType<Worklist, 'id'>): AsyncAction => {
  return {
    type: 'FETCH_WORKLIST_ITEMS_REQUEST',
    payload: worklistId,
    promise: liferay.worklists.items.find(worklistId),
    meta: { onFailure },
  };
};

const saveWorklistItems = (
  itemsParams: UpdateWorklistItemParams[],
  onSuccess?: (savedWorklistItems: WorklistItem[]) => any
): AsyncAction => {
  const promises = itemsParams.map(itemParams => liferay.worklists.items.update(itemParams));
  //$FlowFixMe
  return {
    type: 'SAVE_WORKLIST_ITEMS_REQUEST',
    payload: { itemsParams },
    promise: Promise.all(promises),
    meta: {
      onSuccess,
    },
  };
};

const deleteWorklistItems = (
  items: WorklistItem[],
  worklist: SimplifiedWorklist,
  onSuccess?: (deletedItemIds: number[]) => any
): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'DELETE_WORKLIST_ITEMS_REQUEST',
    payload: { items, worklist },
    promise: liferay.worklists.items.delete(items),
    meta: {
      onFailure,
      onSuccess,
      successMessage: successMessage(
        'rimossa da',
        'rimosse da',
        items.map(item => item.track),
        worklist
      ),
    },
  };
};

const saveWorklistItemsForCheckout = (items: WorklistItem[], worklistId: number): Action => {
  return {
    type: 'SAVE_WORKLIST_ITEMS_FOR_CHECKOUT',
    payload: { items, worklistId },
    meta: { onFailure },
  };
};

export default {
  fetchWorklistList,
  fetchWorklist,
  createWorklist,
  saveWorklist,
  deleteWorklist,
  createWorklistItems,
  fetchWorklistItems,
  saveWorklistItems,
  deleteWorklistItems,
  saveWorklistItemsForCheckout,
  updateWl1,
  updateWl2,
};
